import React, { FC, useCallback, useState } from 'react'
import { Box, Typography } from '@mui/material'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import { EventsFormValues } from './eventsForm.constants'
import EventsFormFields from './EventsFormFields'
import { useEventsFormHandlers } from './useEventsFormHandlers'

interface EventsFormProps {
  values: EventsFormValues
  editingId: string | null
  isSubmitting: boolean
  setFieldValue: (field: keyof EventsFormValues, value: any) => void
  onSubmit: (e?: React.FormEvent) => Promise<void>
  onReset: () => void
}

const EventsForm: FC<EventsFormProps> = ({
  values,
  editingId,
  isSubmitting,
  setFieldValue,
  onSubmit,
  onReset,
}) => {
  const [dateError, setDateError] = useState(false)

  const handlers = useEventsFormHandlers({ setFieldValue, setDateError })

  const handleFormSubmit = useCallback(
    async (e?: React.FormEvent) => {
      e?.preventDefault()
      if (values.date == null) {
        setDateError(true)
      } else {
        setDateError(false)
      }
      await onSubmit(e)
    },
    [values.date, onSubmit]
  )

  return (
    <Box
      sx={{
        mt: 4,
        border: '1px solid #e5e7eb',
        borderRadius: 7,
        p: { xs: 1, md: 5 },
        px: { xs: 2, md: 8 },
        m: 3,
        backgroundColor: '#fff',
      }}
      component="form"
      onSubmit={handleFormSubmit}
    >
      {/* Header */}
      <Box sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        mb: 6,
      }}>
        <FormatListBulletedIcon />
        <Typography variant="h5" fontWeight={500}>
          {editingId ? 'Editar Evento' : 'Agregar Eventos'}
        </Typography>
      </Box>

      <EventsFormFields
        title={values.title}
        place={values.place}
        manager={values.manager}
        site={values.site}
        date={values.date}
        dateError={dateError}
        editingId={editingId}
        isSubmitting={isSubmitting}
        onTitleChange={handlers.handleTitleChange}
        onPlaceChange={handlers.handlePlaceChange}
        onManagerChange={handlers.handleManagerChange}
        onSiteChange={handlers.handleSiteChange}
        onDateChange={handlers.handleDateChange}
        onReset={onReset}
      />
    </Box>
  )
}

export default EventsForm
